module.exports = __webpack_public_path__ + "static/media/Backbeach2.6dae39db.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/Backbeach2.png
// module id = 375
// module chunks = 0